import { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";

const SCROLL_THRESHOLD = 300;

export default function ScrollToTopButton() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setVisible(window.scrollY > SCROLL_THRESHOLD);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = useCallback(() => {
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion ? "instant" : "smooth",
    });
  }, []);

  return (
    <button
      onClick={scrollToTop}
      aria-label={t("scrollToTop")}
      title={t("scrollToTop")}
      className={`
        fixed z-50 bottom-6 right-6
        w-10 h-10
        flex items-center justify-center
        rounded-full
        bg-[#1a8fc1] hover:bg-[#1578a3]
        text-white
        shadow-md
        cursor-pointer whitespace-nowrap
        transition-all duration-300 ease-out
        focus:outline-none focus-visible:ring-2 focus-visible:ring-[#7ec8e3] focus-visible:ring-offset-2 focus-visible:ring-offset-white
        ${visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-4 pointer-events-none"}
      `}
    >
      <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
    </button>
  );
}